import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import SweetAlert from "react-bootstrap-sweetalert";
import { ModalSpinner } from '../../Utils/Loaders';
import { HandleError } from '../../Notifications/APIErrorHandler';
import { Success } from '../../Notifications/Notifications';
import { ModalData } from '../../Modals/ModalData';
import { CustomSelect } from '../../CustomControls/CustomSelect';
import { Add, Save } from '../../Icons/Icons';
import { CustomSearchBox } from '../../CustomControls/CustomSearchBox';

export const ModalAssignPatients = ({patientsPractitionerProp }) => {
    const { t } = useTranslation();

    const {
        dataPatientPractitioner,
        queryPatientPractitioner,
        totalSizePatientPractitioner,
        handleTableChangePatientPractitioner,
        modalPatientsLoading,
        currentPractitionerAssignments,
        handlePatientCheckboxChange,
        handleClosee,
        handleConfirmAssignPatients,
        currentPractitionerIdForAssignment,
        handleFilterChangePatientPractitioner,
        handleSelectAllPatients
    } = patientsPractitionerProp
 
    const modalPatientsColumns = [
        { dataField: 'fullName', text: 'Nombre del Paciente', sort: true },
        {
            dataField: 'assignCheckbox',
            text: 'Asignar',
            formatter: (cellContent, row) => {
                const isPatientCurrentlyAssigned = (currentPractitionerAssignments || []).some(
                    assignment =>
                        assignment.patientId === String(row.medicalRecordNumber) &&
                        assignment.practitionerId === currentPractitionerIdForAssignment 
                );

                return (
                    <input
                        type="checkbox"
                        checked={isPatientCurrentlyAssigned} 
                        onChange={(e) => handlePatientCheckboxChange(row.medicalRecordNumber, e.target.checked)}
                        disabled={modalPatientsLoading} 
                    />
                );
            },
        },
    ];

    if (!currentPractitionerIdForAssignment) {
        return null;
    }

    if (modalPatientsLoading) {
        return <ModalSpinner isShowing={true} />;
        
    }

    const patientStatusOptions = [
        //{ id: 0, code: 'all', title: 'all' },
        { id: 1, code: 'asigned', title: t("protocols.groups.assigned") },
        { id: 2, code: 'unasigned', title: t("protocols.groups.unassigned") },
    ];

    const aux_handleFilterChange = (filterName, selectedValue) => {
        handleFilterChangePatientPractitioner(filterName, selectedValue, currentPractitionerIdForAssignment)
    }

    return (
        <>
            <ModalData
                isShowing={true}
                hide={handleClosee}
                title={t("protocols.groups.assginedPatientsTitle")}
                size="medium"
                className=""
                footer={
                    <>
                        <button type="button" className="btn" onClick={handleClosee} >{t("buttons.cancel")}</button>
                        {' '}
                        <button type="button" className="btn btn-success btn-primary btn-rightt" onClick={handleConfirmAssignPatients} >{t("buttons.confirm")}</button>
                    </>
                }
            >
                <div className="row" >

                    <div className="col-md-4">
                        <CustomSearchBox handleSearch={(value) => handleFilterChangePatientPractitioner("FullName", value, currentPractitionerIdForAssignment)} placeholder={t('protocols.visitTracking.searchByNumber')}></CustomSearchBox>
                    </div>

                    <div className="col-md-4">
                        <CustomSelect
                            name="AssignmentStatus"
                            placeholder={t("protocols.groups.all")}
                            onChange={aux_handleFilterChange}
                            //onChange={(selectedValue) => handleFilterChangePatientPractitioner("AssignmentStatus", selectedValue, currentPractitionerIdForAssignment)}
                            isMulti={false}
                            isClearable={true}
                            options={patientStatusOptions}
                        />
                    </div>

                    <div className="col-md-4"
                        style={{
                            color: '#636466',
                            fontWeight: 'normal',
                            fontSize: '16px',
                            fontFamily: 'Montserrat'
                        }}>
                        Todos{' '}
                        <input
                            type="checkbox"
                            //checked={}
                            onChange={(e) => handleSelectAllPatients(e.target.checked)}
                            disabled={modalPatientsLoading}
                        />
                    </div>
                    
                </div>

                <BootstrapTable
                    classes="table-spaced table-spaced-small"
                    wrapperClasses="table-responsive"
                    keyField="medicalRecordNumber"
                    key={JSON.stringify(currentPractitionerAssignments)}
                    data={dataPatientPractitioner}
                    columns={modalPatientsColumns}
                    bootstrap4
                    bordered={false}
                    hover
                    remote
                    pagination={paginationFactory({
                        page: queryPatientPractitioner.pagination.page,
                        sizePerPage: queryPatientPractitioner.pagination.sizePerPage,
                        totalSize: totalSizePatientPractitioner,
                        hideSizePerPage: true,
                        hidePageList: false,
                    })}
                    onTableChange={handleTableChangePatientPractitioner}
                    noDataIndication={() => <>{t("commons.noData")}</>}
                />
            </ModalData>
        </>
        
    );
};

ModalAssignPatients.propTypes = {
    patientsPractitionerProp: PropTypes.object.isRequired,  
};